import { useConfigMC, useData } from '~/store/Query/api';
import { ATTR_LIMITE_INVENTARIO } from '~/store/States/global';
import { inventoryState } from '~/store/States/inventory';

export default function InventoryAlert({ item }) {
  const config = useData(useConfigMC);

  if (!config) {
    return null;
  }

  const qty = inventoryState.nested(item.part_number).value;
  const limit = item.attrMap[ATTR_LIMITE_INVENTARIO];
  const limitAlert = limit && qty <= +limit ? qty : 0;
  return (
    limitAlert > 0 && (
      <div className="inv--alert">
        {(config.inventario.alerta[limitAlert] ?? config.inventario.alerta._).replace('{CANTIDAD}', limitAlert)}
      </div>
    )
  );
}
